import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import PopUpLink from 'components/Common/GlobalPopUps/PopUpLink';

import * as formatter from 'mt-react-common/utils/formatter';
import CSSTransition from 'react-transition-group/CSSTransition';
import {
  selectChildIdsByParentId,
  selectChildItemById
} from 'mt-react-common/common/reducers/__childMultipleList/reducer';
import { childCommentsReduceName } from 'mt-react-common/modules/comments/reducers/list/reducer';
import { connect } from 'react-redux';
import CommentChildFormRWrapper from '../ReducerWrappers/CommentChildFormRWrapper/index';

class CommentItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSubCommentForm: false
    };
  }

  handleShowSubForm = event => {
    event.preventDefault();
    this.setState({
      showSubCommentForm: !this.state.showSubCommentForm
    });
  };

  hideSubForm = () => {
    this.setState({
      showSubCommentForm: false
    });
  };

  render() {
    const likeIcon = like => {
      if (like === 1) {
        return (
          <span className="text-primary">
            <i className="fa fa-thumbs-o-up" />
          </span>
        );
      } else if (like === -1) {
        return (
          <span className="text-primary">
            <i className="fa fa-thumbs-o-down" />
          </span>
        );
      }
      return null;
    };

    const commentTitleLink = modelClass => {
      if (modelClass === 765557111) {
        return (
          <h2 className="panel-title">
            <NavLink
              to={`/users/profile/${this.props.comment.modelId}/comments`}
            >
              {this.props.comment.commentTitle}
            </NavLink>
          </h2>
        );
      } else if (modelClass === 2442742419) {
        return (
          <h2 className="panel-title">
            <NavLink to={`/earn-money/task-view/${this.props.comment.modelId}`}>
              {this.props.comment.commentTitle}
            </NavLink>
          </h2>
        );
      }
      return null;
    };

    return (
      <article className="panel panel-default">
        {this.props.hasShowTitleLink ? (
          <div className="panel-heading">
            {commentTitleLink(this.props.comment.modelClass)}
          </div>
        ) : null}
        <div className="panel-body">
          <div className="media media_comment media_comment_default media-tools_hover">
            <div className="media-left">
              <img
                alt=""
                className="media-object avatar avatar-sm"
                src={this.props.comment.authorAvatarPath}
              />
            </div>
            <div className="media-body">
              <div className="media-content">
                <div className="media-info">
                  <div className="media-tools">
                    <a href="" onClick={this.handleShowSubForm}>
                      <i className="fa fa-comment" />
                      &nbsp;
                    </a>
                    <PopUpLink
                      hashName="commentComplaint"
                      hashParams={{ id: this.props.comment.id }}
                    >
                      <i className="fa fa-exclamation-triangle" />
                    </PopUpLink>
                  </div>
                  <NavLink
                    to={`/users/profile/${this.props.comment.authorId}/comments`}
                    className="media-info-name"
                    title={this.props.comment.authorUserName}
                  >
                    {this.props.comment.authorUserName}
                  </NavLink>
                  <div className="media-info-desc">
                    <span className="text-muted">
                      {formatter.dateFormat1(this.props.comment.createdAt)}
                      &nbsp;&nbsp;
                    </span>
                    {likeIcon(this.props.comment.like)}
                  </div>
                </div>
                <div className="media-content-data">
                  {this.props.comment.content}
                </div>
              </div>
              {this.props.childItems.map(childCommentId => {
                const childComment = this.props.selectChildItemById(
                  childCommentId
                );
                return (
                  <div
                    key={childComment.id}
                    className="media media_comment media_comment_default media-tools_hover"
                  >
                    <div className="media-left avatar-sm">
                      <img
                        alt=""
                        className="media-object avatar avatar-sm"
                        src={childComment.authorAvatarPath}
                      />
                    </div>
                    <div className="media-body">
                      <div className="media-content">
                        <div className="media-info">
                          <div className="media-tools">
                            <PopUpLink
                              hashName="commentComplaint"
                              hashParams={{ id: childComment.id }}
                            >
                              <i className="fa fa-exclamation-triangle" />
                            </PopUpLink>
                          </div>
                          <NavLink
                            to={`/users/profile/${childComment.authorId}/comments`}
                            className="media-info-name"
                            title={childComment.authorUserName}
                          >
                            {childComment.authorUserName}
                          </NavLink>
                          <div className="media-info-desc">
                            {formatter.dateFormat1(childComment.createdAt)}
                            &nbsp;&nbsp;
                            {likeIcon(childComment.like)}
                          </div>
                        </div>
                        <div className="media-content-data">
                          {childComment.content}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
              <CSSTransition
                in={this.state.showSubCommentForm}
                classNames=""
                timeout={300}
                unmountOnExit
                onEnter={() => {
                  // eslint-disable-next-line no-undef
                  $(`#formComment${this.props.comment.id}`).collapse('show');
                }}
                onExiting={() => {
                  // eslint-disable-next-line no-undef
                  $(`#formComment${this.props.comment.id}`).collapse('hide');
                }}
              >
                <div
                  key={`formComment${this.props.comment.id}`}
                  id={`formComment${this.props.comment.id}`}
                  className="collapse"
                >
                  <CommentChildFormRWrapper
                    listReducerName={this.props.reducerName}
                    modelClass={this.props.comment.modelClass}
                    modelId={this.props.comment.modelId}
                    parentId={this.props.comment.id}
                    hideSubForm={this.hideSubForm}
                  />
                </div>
              </CSSTransition>
            </div>
          </div>
        </div>
      </article>
    );
  }
}

CommentItem.defaultProps = {
  hasShowTitleLink: false
};

CommentItem.propTypes = {
  comment: PropTypes.shape().isRequired,
  childItems: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectChildItemById: PropTypes.func.isRequired,
  reducerName: PropTypes.string.isRequired,
  hasShowTitleLink: PropTypes.bool
};

const mapStateToProps = (state, props) => ({
  childItems: selectChildIdsByParentId(
    state,
    props.reducerName,
    childCommentsReduceName,
    props.comment.id
  ),
  selectChildItemById: id =>
    selectChildItemById(state, props.reducerName, childCommentsReduceName, id)
});

export default connect(mapStateToProps)(CommentItem);



// WEBPACK FOOTER //
// ./src/components/Comment/CommentItem/CommentItem.js